import { useState, useEffect, VFC } from "react";
// Libraries
import { useHistory, Redirect, useParams } from "react-router-dom";
// Utils
import { GROUPS, GROUP_VIEW } from "constants/Routes";
import { ELEMENTS_IDS } from "constants/ElementsIds";
// Hooks
import { useGetGroupById, useEventRequest, useStateSpecies } from "hooks";
// Components
import { GroupInfoBlock } from "components/MyLivestock";
import AssignAnimalsToGroup from "pages/MyLivestock/Groups/AssignAnimalsToGroup";
import { Button, Breadcrumbs, LoadingOverlay, Header, PageContent, PageHeader, Spacer } from "components";
// Resources
import styles from "./GroupView.module.scss";

const GroupView: VFC = () => {
  const { active: speciesActive } = useStateSpecies();

  const { groupId } = useParams<LivestockGroupPageParams>();

  const history = useHistory();
  const { eventsRequest } = useEventRequest();
  const [isEdited, changeEditMode] = useState<string | null>(null);

  useEffect(() => {
    eventsRequest({ name: "group-view", details: { groupId } });
  }, []);

  const { data, loading, error } = useGetGroupById(groupId);
  const group = data?.group || null;

  if (error) return <Redirect to={GROUPS} />;

  if (!group) {
    if (loading) return <LoadingOverlay customStyles={styles.loadingOverlay} />;

    return <Redirect to={GROUPS} />;
  }

  if (speciesActive) {
    const isGroupDifferentSpecies = group.animalType?.id !== speciesActive.id;
    if (isGroupDifferentSpecies) return <Redirect to={GROUPS} />;
  }

  return (
    <>
      <PageHeader>
        <Breadcrumbs
          rootPaths={[
            {
              path: "Groups",
              route: GROUPS,
            },
          ]}
          currentPath="Group Information"
        />

        <Header backButton title={group.name || ""} />

        <GroupInfoBlock group={group}>
          {!isEdited && (
            <Button
              id={ELEMENTS_IDS.EDIT_GROUP_BUTTON}
              caption="Edit group"
              onClick={(): void => history.push(`${GROUP_VIEW}/edit/${group.id}`)}
            />
          )}
        </GroupInfoBlock>

        <Spacer baselineHeight={3} />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={3} />

        <AssignAnimalsToGroup isEdited={isEdited} changeEditMode={changeEditMode} />
      </PageContent>
    </>
  );
};

export default GroupView;
